/**
 * Sum a `{ label: count }` conversions map.
 *
 * Returns 0 for an empty or missing map — `reduce` without an initial value
 * throws on an empty array, which previously crashed the Organic feed tab.
 */
export function totalConversions(conversions) {
  if (!conversions || typeof conversions !== 'object') return 0;

  return Object.values(conversions).reduce((total, value) => {
    return Number.isFinite(value) ? total + value : total;
  }, 0);
}
